

export class FileTimestamp {
    Name: string;
    FileDate: string;

    initialize(): void { }
}